export const odiVsBfcLeaderboardList = [
  {
    _id: '635a2c90027fb4001b93a114',
    winning: 500000,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '635a2c85027fb4001b93a110',
    captainId: '6352d39ae1e4df00fa126b00',
    viceCaptainId: '6352d39ae1e4df00fa126b16',
    score: 336,
    verifiedScore: 336,
    username: 'Kamal',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b0a',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126aeb',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126afb',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b00',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af7',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126b09',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a160',
    winning: 400000,
    rank: 2,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 1,
    matchTeamId: '635a354b027fb4001b93a123',
    captainId: '6352d39ae1e4df00fa126aec',
    viceCaptainId: '6352d39ae1e4df00fa126aed',
    score: 250,
    verifiedScore: 250,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b0a',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126aec',
        rating: 7.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b12',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b1b',
        rating: 8,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a161',
    winning: 250000,
    rank: 3,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 2,
    matchTeamId: '635a3553027fb4001b93a124',
    captainId: '6352d39ae1e4df00fa126aec',
    viceCaptainId: '6352d39ae1e4df00fa126b12',
    score: 233,
    verifiedScore: 233,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b0a',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126aec',
        rating: 7.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b12',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b1b',
        rating: 8,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a163',
    winning: 250000,
    rank: 3,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 4,
    matchTeamId: '635a3561027fb4001b93a126',
    captainId: '6352d39ae1e4df00fa126aec',
    viceCaptainId: '6352d39ae1e4df00fa126b12',
    score: 233,
    verifiedScore: 233,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b19',
        rating: 8,
        teamId: 454,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126aec',
        rating: 7.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b12',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b1b',
        rating: 8,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a164',
    winning: 75000,
    rank: 5,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 5,
    matchTeamId: '635a3575027fb4001b93a127',
    captainId: '6352d39ae1e4df00fa126aed',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 219,
    verifiedScore: 219,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126af2',
        rating: 6.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b12',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a165',
    winning: 75000,
    rank: 5,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 6,
    matchTeamId: '635a3582027fb4001b93a128',
    captainId: '6352d39ae1e4df00fa126aed',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 219,
    verifiedScore: 219,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b1c',
        rating: 4.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b12',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a166',
    winning: 50000,
    rank: 7,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 7,
    matchTeamId: '635a3591027fb4001b93a129',
    captainId: '6352d39ae1e4df00fa126aed',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 217,
    verifiedScore: 217,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126af2',
        rating: 6.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae0',
        rating: 7.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a167',
    winning: 50000,
    rank: 7,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 8,
    matchTeamId: '635a3599027fb4001b93a12a',
    captainId: '6352d39ae1e4df00fa126aed',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 217,
    verifiedScore: 217,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126b1c',
        rating: 4.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae0',
        rating: 7.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a168',
    winning: 50000,
    rank: 9,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 9,
    matchTeamId: '635a35ac027fb4001b93a12c',
    captainId: '6352d39ae1e4df00fa126ae6',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 207,
    verifiedScore: 207,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126af2',
        rating: 6.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae0',
        rating: 7.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a169',
    winning: 50000,
    rank: 9,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 10,
    matchTeamId: '635a35b8027fb4001b93a12d',
    captainId: '6352d39ae1e4df00fa126ae6',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 207,
    verifiedScore: 207,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126aef',
        rating: 7,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae0',
        rating: 7.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af7',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a162',
    winning: 50000,
    rank: 11,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 3,
    matchTeamId: '635a355a027fb4001b93a125',
    captainId: '6352d39ae1e4df00fa126aec',
    viceCaptainId: '6352d39ae1e4df00fa126b12',
    score: 200,
    verifiedScore: 200,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126af2',
        rating: 6.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126b16',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126aec',
        rating: 7.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b12',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126b1b',
        rating: 8,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af5',
        rating: 8.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '635a35f4027fb4001b93a16a',
    winning: 50000,
    rank: 12,
    tenant: 'dev',
    userId: '61ee43ad6c129b0021d9e01c',
    firstname: 'Shiva Agarwal',
    lastname: 'Agarwal',
    teamNumber: 11,
    matchTeamId: '635a35c3027fb4001b93a12e',
    captainId: '6352d39ae1e4df00fa126ae6',
    viceCaptainId: '6352d39ae1e4df00fa126ae8',
    score: 170,
    verifiedScore: 170,
    username: '22062408561745870',
    players: [
      {
        playerId: '6352d39ae1e4df00fa126af2',
        rating: 6.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '6352d39ae1e4df00fa126afb',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b17',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b11',
        rating: 8,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126b18',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '6352d39ae1e4df00fa126adc',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae6',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126aed',
        rating: 8,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae0',
        rating: 7.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '6352d39ae1e4df00fa126af7',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '6352d39ae1e4df00fa126ae8',
        rating: 7.5,
        teamId: 454,
        role: 'Forward'
      }
    ]
  }
];

export const cfcVsBfcResultLeaderboardList = [
  {
    _id: '634966d4b99cfd001d9cf536',
    winning: 350000,
    rank: 2,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 6,
    matchTeamId: '634966c7b99cfd001d9cf522',
    captainId: '63445a98746a9884afab39f3',
    viceCaptainId: '63445a98746a9884afab3a2e',
    score: 387,
    verifiedScore: 387,
    username: 'Kamal',
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '634966d4b99cfd001d9cf532',
    winning: 50000,
    rank: 6,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 2,
    matchTeamId: '634966b2b99cfd001d9cf51e',
    captainId: '63445a98746a9884afab3a19',
    viceCaptainId: '63445a98746a9884afab3a05',
    score: 368.5,
    verifiedScore: 368.5,
    username: 'Kamal',
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '634966d4b99cfd001d9cf533',
    winning: 50000,
    rank: 7,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 3,
    matchTeamId: '634966b7b99cfd001d9cf51f',
    captainId: '63445a98746a9884afab3a19',
    viceCaptainId: '63445a98746a9884afab3a00',
    score: 367.5,
    verifiedScore: 367.5,
    username: 'Kamal',
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '634966d4b99cfd001d9cf535',
    winning: 50000,
    rank: 9,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 5,
    matchTeamId: '634966c2b99cfd001d9cf521',
    captainId: '63445a98746a9884afab39fb',
    viceCaptainId: '63445a98746a9884afab3a2e',
    score: 355,
    verifiedScore: 355,
    username: 'Kamal',
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '634966d4b99cfd001d9cf534',
    winning: 50000,
    rank: 10,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 4,
    matchTeamId: '634966bcb99cfd001d9cf520',
    captainId: '63445a98746a9884afab39fb',
    viceCaptainId: '63445a98746a9884afab3a00',
    score: 352.5,
    verifiedScore: 352.5,
    username: 'Kamal',
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6349669eb99cfd001d9cf518',
    winning: 50000,
    rank: 11,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63496691b99cfd001d9cf514',
    captainId: '63445a98746a9884afab39f2',
    viceCaptainId: '63445a98746a9884afab3a05',
    score: 351.5,
    verifiedScore: 351.5,
    username: 'Kamal',
    players: [
      {
        playerId: '63445a98746a9884afab39f5',
        rating: 8.5,
        teamId: 451,
        role: 'Goalkeeper'
      },
      {
        playerId: '63445a98746a9884afab39f2',
        rating: 9,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a05',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a19',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab3a00',
        rating: 8.5,
        teamId: 451,
        role: 'Defender'
      },
      {
        playerId: '63445a98746a9884afab39fb',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a2e',
        rating: 8.5,
        teamId: 451,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab3a41',
        rating: 7,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '63445a98746a9884afab39f3',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab39f4',
        rating: 9,
        teamId: 451,
        role: 'Forward'
      },
      {
        playerId: '63445a98746a9884afab3a0b',
        rating: 8.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  }
];

export const atkMBVsCfcLeaderboardList = [
  {
    _id: '6343f00bc2760c001bcd40b2',
    winning: 500000,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '6343eaafc2760c001bcd40ad',
    captainId: '633fb1e0746a9884af2fbe2e',
    viceCaptainId: '633fb1e0746a9884af2fbe34',
    score: 59,
    verifiedScore: 59,
    username: 'Kamal',
    players: [
      {
        teamId: 453,
        role: 'Goalkeeper',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe30'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2e'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe34'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe51'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe37'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe44'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2d'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe31'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe4a'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe33'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe45'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40ce',
    winning: 400000,
    rank: 2,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 7,
    matchTeamId: '6343fdc3c2760c001bcd40c2',
    captainId: '633fb1e0746a9884af2fbe30',
    viceCaptainId: '633fb1e0746a9884af2fbe37',
    score: 33,
    verifiedScore: 33,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe30',
        rating: 8.5,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe6b',
        rating: 9,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4c',
        rating: 9,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343e705c2760c001bcd409c',
    winning: 300000,
    rank: 3,
    tenant: 'dev',
    userId: '624ea7be924a55001ea4aa2e',
    firstname: 'ritadhi',
    lastname: 'roy',
    teamNumber: 2,
    matchTeamId: '6343e6c7c2760c001bcd408a',
    captainId: '633fb1e0746a9884af2fbe34',
    viceCaptainId: '633fb1e0746a9884af2fbe2e',
    score: 32.5,
    verifiedScore: 32.5,
    username: 'ritadhi',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe4f',
        rating: 8.5,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe35',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe5b',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3a',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343e705c2760c001bcd409d',
    winning: 200000,
    rank: 4,
    tenant: 'dev',
    userId: '624ea7be924a55001ea4aa2e',
    firstname: 'ritadhi',
    lastname: 'roy',
    teamNumber: 3,
    matchTeamId: '6343e6d1c2760c001bcd408b',
    captainId: '633fb1e0746a9884af2fbe34',
    viceCaptainId: '633fb1e0746a9884af2fbe53',
    score: 32.25,
    verifiedScore: 32.25,
    username: 'ritadhi',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe4f',
        rating: 8.5,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe35',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe5b',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3a',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343e705c2760c001bcd409b',
    winning: 100000,
    rank: 5,
    tenant: 'dev',
    userId: '624ea7be924a55001ea4aa2e',
    firstname: 'ritadhi',
    lastname: 'roy',
    teamNumber: 1,
    matchTeamId: '6343e6bcc2760c001bcd4089',
    captainId: '633fb1e0746a9884af2fbe4f',
    viceCaptainId: '633fb1e0746a9884af2fbe2e',
    score: 29.5,
    verifiedScore: 29.5,
    username: 'ritadhi',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe4f',
        rating: 8.5,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe35',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe5b',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3a',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40cc',
    winning: 50000,
    rank: 6,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 5,
    matchTeamId: '6343fdacc2760c001bcd40bf',
    captainId: '633fb1e0746a9884af2fbe49',
    viceCaptainId: '633fb1e0746a9884af2fbe37',
    score: 26.5,
    verifiedScore: 26.5,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe30',
        rating: 8.5,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe6b',
        rating: 9,
        teamId: 453,
        role: 'Forward'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4c',
        rating: 9,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343e3ddc2760c001bcd4085',
    winning: 50000,
    rank: 7,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 2,
    matchTeamId: '6343e049c2760c001bcd4081',
    captainId: '633fb1e0746a9884af2fbe51',
    viceCaptainId: '633fb1e0746a9884af2fbe53',
    score: 25.25,
    verifiedScore: 25.25,
    username: 'tushar0902',
    players: [
      {
        teamId: 453,
        role: 'Goalkeeper',
        rating: 8,
        playerId: '633fb1e0746a9884af2fbe6c'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2e'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe34'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe49'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe51'
      },
      {
        teamId: 453,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe53'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe37'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe3b'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe69'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe42'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe4a'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40d1',
    winning: 50000,
    rank: 8,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 10,
    matchTeamId: '6343fdedc2760c001bcd40c9',
    captainId: '633fb1e0746a9884af2fbe34',
    viceCaptainId: '633fb1e0746a9884af2fbe2e',
    score: 25,
    verifiedScore: 25,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe74',
        rating: 0,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe42',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40d2',
    winning: 50000,
    rank: 8,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 11,
    matchTeamId: '6343fe01c2760c001bcd40cb',
    captainId: '633fb1e0746a9884af2fbe2e',
    viceCaptainId: '633fb1e0746a9884af2fbe34',
    score: 25,
    verifiedScore: 25,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe52',
        rating: 8,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe42',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343e6f5c2760c001bcd4098',
    winning: 50000,
    rank: 10,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 1,
    matchTeamId: '6343e00cc2760c001bcd407f',
    captainId: '633fb1e0746a9884af2fbe53',
    viceCaptainId: '633fb1e0746a9884af2fbe51',
    score: 24.75,
    verifiedScore: 24.75,
    username: 'tushar0902',
    players: [
      {
        teamId: 453,
        role: 'Goalkeeper',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe4f'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2e'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe34'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe49'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe51'
      },
      {
        teamId: 453,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe53'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe37'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe3b'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe69'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe42'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe4a'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40cd',
    winning: 50000,
    rank: 10,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 6,
    matchTeamId: '6343fdb9c2760c001bcd40c1',
    captainId: '633fb1e0746a9884af2fbe2e',
    viceCaptainId: '633fb1e0746a9884af2fbe53',
    score: 24.75,
    verifiedScore: 24.75,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe6c',
        rating: 8,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe42',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40cf',
    winning: 50000,
    rank: 10,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 8,
    matchTeamId: '6343fdd0c2760c001bcd40c5',
    captainId: '633fb1e0746a9884af2fbe34',
    viceCaptainId: '633fb1e0746a9884af2fbe53',
    score: 24.75,
    verifiedScore: 24.75,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe74',
        rating: 0,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe42',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343fe2ac2760c001bcd40d0',
    winning: 50000,
    rank: 13,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 9,
    matchTeamId: '6343fde2c2760c001bcd40c8',
    captainId: '633fb1e0746a9884af2fbe51',
    viceCaptainId: '633fb1e0746a9884af2fbe54',
    score: 24,
    verifiedScore: 24,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe54',
        rating: 8,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe42',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '6343fd9bc2760c001bcd40b8',
    winning: 50000,
    rank: 14,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 3,
    matchTeamId: '6343efdec2760c001bcd40ae',
    captainId: '633fb1e0746a9884af2fbe51',
    viceCaptainId: '633fb1e0746a9884af2fbe37',
    score: 23.5,
    verifiedScore: 23.5,
    username: 'tushar0902',
    players: [
      {
        teamId: 453,
        role: 'Goalkeeper',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe4f'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe2e'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe34'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe49'
      },
      {
        teamId: 2029,
        role: 'Defender',
        rating: 8.5,
        playerId: '633fb1e0746a9884af2fbe51'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe37'
      },
      {
        teamId: 2029,
        role: 'Midfielder',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe3b'
      },
      {
        teamId: 453,
        role: 'Midfielder',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe69'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9.5,
        playerId: '633fb1e0746a9884af2fbe4a'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe6b'
      },
      {
        teamId: 453,
        role: 'Forward',
        rating: 9,
        playerId: '633fb1e0746a9884af2fbe4c'
      }
    ]
  },
  {
    _id: '6343fd9bc2760c001bcd40b9',
    winning: 50000,
    rank: 15,
    tenant: 'dev',
    userId: '634015102f3919002043e9a7',
    firstname: null,
    lastname: null,
    teamNumber: 4,
    matchTeamId: '6343f035c2760c001bcd40b7',
    captainId: '633fb1e0746a9884af2fbe49',
    viceCaptainId: '633fb1e0746a9884af2fbe53',
    score: 21.75,
    verifiedScore: 21.75,
    username: 'tushar0902',
    players: [
      {
        playerId: '633fb1e0746a9884af2fbe4f',
        rating: 8.5,
        teamId: 453,
        role: 'Goalkeeper'
      },
      {
        playerId: '633fb1e0746a9884af2fbe2e',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe34',
        rating: 9,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe49',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe51',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe53',
        rating: 8.5,
        teamId: 453,
        role: 'Defender'
      },
      {
        playerId: '633fb1e0746a9884af2fbe37',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe3b',
        rating: 9.5,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe69',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe42',
        rating: 9,
        teamId: 453,
        role: 'Midfielder'
      },
      {
        playerId: '633fb1e0746a9884af2fbe4a',
        rating: 9.5,
        teamId: 453,
        role: 'Forward'
      }
    ]
  }
];
export const jfcVsMcfLeaderBoardData = [
  {
    _id: '63d33e3b8d8436001e1bedb9',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d33e348d8436001e1bedb8',
    captainId: '63cb036d6bc8d3ddb965eeb0',
    viceCaptainId: '63cb036d6bc8d3ddb965eea1',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cb036d6bc8d3ddb965eeb4',
        rating: 7.5,
        teamId: 458,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea2',
        rating: 8.5,
        teamId: 458,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965ee9a',
        rating: 8,
        teamId: 460,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eeac',
        rating: 8,
        teamId: 458,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eeb7',
        rating: 8,
        teamId: 458,
        role: 'Defender'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eec1',
        rating: 9,
        teamId: 458,
        role: 'Midfielder'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea1',
        rating: 8.5,
        teamId: 458,
        role: 'Midfielder'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eeb0',
        rating: 8.5,
        teamId: 460,
        role: 'Midfielder'
      },
      {
        playerId: '63cb036d6bc8d3ddb965ee9b',
        rating: 9,
        teamId: 458,
        role: 'Forward'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea3',
        rating: 9,
        teamId: 460,
        role: 'Forward'
      },
      {
        playerId: '63cb036d6bc8d3ddb965eea4',
        rating: 8,
        teamId: 460,
        role: 'Forward'
      }
    ]
  }
];
export const kerVsNorLeaderBoardData = [
  {
    _id: '63d3bf278d8436001e1bee01',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d341578d8436001e1bedc0',
    captainId: '63d29b536bc8d3ddb9784145',
    viceCaptainId: '63d29b536bc8d3ddb9784157',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63d29b536bc8d3ddb978416a',
        rating: 7,
        teamId: 459,
        role: 'Goalkeeper'
      },
      {
        playerId: '63d29b536bc8d3ddb9784154',
        rating: 8,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784137',
        rating: 7.5,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784145',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784157',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb978416b',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784170',
        rating: 9,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978414e',
        rating: 8.5,
        teamId: 459,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978417f',
        rating: 8.5,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978415a',
        rating: 8,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb9784183',
        rating: 9,
        teamId: 457,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '63d3bf408d8436001e1bee06',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 2,
    matchTeamId: '63d3bf3a8d8436001e1bee05',
    captainId: '63d29b536bc8d3ddb978416b',
    viceCaptainId: '63d29b536bc8d3ddb9784170',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63d29b536bc8d3ddb978416a',
        rating: 7,
        teamId: 459,
        role: 'Goalkeeper'
      },
      {
        playerId: '63d29b536bc8d3ddb9784154',
        rating: 8,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784137',
        rating: 7.5,
        teamId: 457,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784145',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784157',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb978416b',
        rating: 7.5,
        teamId: 459,
        role: 'Defender'
      },
      {
        playerId: '63d29b536bc8d3ddb9784170',
        rating: 9,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978414e',
        rating: 8.5,
        teamId: 459,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978417f',
        rating: 8.5,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb978415a',
        rating: 8,
        teamId: 457,
        role: 'Midfielder'
      },
      {
        playerId: '63d29b536bc8d3ddb9784183',
        rating: 9,
        teamId: 457,
        role: 'Forward'
      }
    ]
  }
];
export const atkVsOdiLeaderboardData = [
  {
    _id: '63d3c0d88d8436001e1bee0b',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 1,
    matchTeamId: '63d3c0d48d8436001e1bee0a',
    captainId: '63cda5006bc8d3ddb9c9292e',
    viceCaptainId: '63cda5006bc8d3ddb9c928fe',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cda5006bc8d3ddb9c92975',
        rating: 8,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928e8',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92945',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92976',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92944',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92971',
        rating: 9,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928fe',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c9292e',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928e9',
        rating: 8,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92922',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '63cda5006bc8d3ddb9c9297e',
        rating: 9,
        teamId: 454,
        role: 'Forward'
      }
    ]
  },
  {
    _id: '63d3c0ef8d8436001e1bee10',
    winning: 0,
    rank: 1,
    tenant: 'dev',
    userId: '601cd58656c4dd5b565191e9',
    firstname: 'Kamal',
    lastname: 'Vermag',
    teamNumber: 2,
    matchTeamId: '63d3c0eb8d8436001e1bee0f',
    captainId: '63cda5006bc8d3ddb9c92976',
    viceCaptainId: '63cda5006bc8d3ddb9c92944',
    score: 0,
    username: 'Kamal',
    players: [
      {
        playerId: '63cda5006bc8d3ddb9c92975',
        rating: 8,
        teamId: 2029,
        role: 'Goalkeeper'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928e8',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92945',
        rating: 8.5,
        teamId: 2029,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92976',
        rating: 8.5,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92944',
        rating: 8,
        teamId: 454,
        role: 'Defender'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92967',
        rating: 9,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92971',
        rating: 9,
        teamId: 2029,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c928fe',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c9292e',
        rating: 8.5,
        teamId: 454,
        role: 'Midfielder'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92922',
        rating: 9,
        teamId: 2029,
        role: 'Forward'
      },
      {
        playerId: '63cda5006bc8d3ddb9c92949',
        rating: 9,
        teamId: 454,
        role: 'Forward'
      }
    ]
  }
];
